import DefaultLayout from './default.vue';

export default {
  default: DefaultLayout,
};
